import { SourcingStatus } from 'api-clients/monolith';
import clsx from 'clsx';

import { Skeleton } from '@/components/ui/skeleton';
import { Tooltip } from '@/components/ui/tooltip';
import { Typography } from '@/components/ui/typography';

import { useSourcingStatus } from './use-sourcing-status';

interface SourcingStatusPillProps {
  status: SourcingStatus;
}

export function SourcingStatusPill({ status }: SourcingStatusPillProps) {
  const { bgColor, tooltip, title } = useSourcingStatus(status);

  if (!status) return null;

  return (
    <Tooltip content={tooltip}>
      <div
        className={clsx(
          'flex h-6 w-fit items-center justify-center rounded px-2',
          bgColor,
        )}
      >
        <Typography variant="small1" className="!text-fx-neutral-600">
          {title}
        </Typography>
      </div>
    </Tooltip>
  );
}

SourcingStatusPill.Skeleton = function StatusPillSkeleton() {
  return <Skeleton className="w-18 h-6 !rounded" />;
};
